// extracted by mini-css-extract-plugin
export default {"root":"nDmqzY","monthDay":"bhDhoO","weekAndMonth":"URfCjA","weekDay":"etdqQ8","month":"PVEZFc","listHeaderTitle":"xgQ8vn","color":"AqK082","srOnly":"NJMnST"};